import { FC, useMemo } from 'react'
import { Button, MotivatorBadge, useAnalytic } from 'src/components'
import { EMotivator, ETrackingEvent } from 'src/enums'
import { ICampaignModel } from 'src/interfaces'
import { CampaignVideoCard } from 'src/partials/card/campaign-video-card'
import { JobInfo } from '../job-info'
import Style from './style.module.scss'

interface IProps {
  campaign: Partial<ICampaignModel>
  analyticScreen?: string
  onDetail?: () => void
}

export const JobCard: FC<IProps> = ({ campaign, analyticScreen, onDetail }) => {
  const { analytic } = useAnalytic(analyticScreen)

  const motivators = useMemo(() => {
    return (campaign?.recommendKey?.split('.') ?? []) as Array<EMotivator>
  }, [campaign?.recommendKey])

  return (
    <div className={Style.cContainer}>
      <CampaignVideoCard campaign={campaign} autoPlayer/>

      <div className="fx-column gap-5">
        <div className="fx-column gap-2">
          <div className="fw-700 fs-20 lh-24 txt-black-01 three-dot-1">
            {campaign.jobTitle}
          </div>
          <div className="fx gap-1" style={{ minHeight: 24 }}>
            {motivators.map(motivator => (
              <MotivatorBadge key={motivator} small value={motivator}/>
            ))}
          </div>
        </div>

        <JobInfo campaign={campaign}/>

        <div className="fx gap-4">
          <Button
            onClick={() => {
              analytic(ETrackingEvent.BTN_JOB_DETAILS)
              onDetail?.()
            }}
          >
            Details
          </Button>
        </div>
      </div>
    </div>
  )
}
